import { ServiceField } from "../models/Service";

// A template claims the field codes it draws with its own inputs. Everything
// else is the configured slot's to render.
export type FieldClaims = readonly string[];

// Claims are CONSUMING, one occurrence each: `submitFields` carries no
// uniqueItems and fieldId is a semantic type, not a key, so a service may
// declare the same code twice — a payment number and a contact number are
// both CUSPHONE, told apart only by their labels. Dropping every match would
// suppress both and silently remove a mandatory input from a payment form.
export const unclaimedFields = (
  fields: ServiceField[],
  claims: FieldClaims
): ServiceField[] => {
  const unconsumed = [...claims];

  return fields.filter(field => {
    const at = unconsumed.indexOf(field.fieldId);
    if (at === -1) return true;

    unconsumed.splice(at, 1);
    return false;
  });
};
